import { zonedTimeToUtc } from 'date-fns-tz';

export const isLessThan10MinutesAgo = (dateString: string): boolean => {
  const timeZone = 'America/New_York';

  const inputDate = zonedTimeToUtc(dateString.replace(' ', 'T'), timeZone);
  const now = zonedTimeToUtc(new Date(), timeZone);

  const diffInMs = now.getTime() - inputDate.getTime();
  const diffInMinutes = diffInMs / (1000 * 60);

  return diffInMinutes >= 0 && diffInMinutes < 10;
};

export const diffInMinutes = (dateString: string): number => {
  const timeZone = 'America/New_York';

  const inputDate = zonedTimeToUtc(dateString.replace(' ', 'T'), timeZone);
  const now = zonedTimeToUtc(new Date(), timeZone);

  const diffInMs = now.getTime() - inputDate.getTime();

  return 10 - Math.floor(diffInMs / (1000 * 60));
};
